/* eslint-disable import/prefer-default-export */
import { getOr, get } from 'lodash/fp';

export const getAccessToken = getOr(
    'FIXME_NO_ACCESS_TOKEN_AVAILABLE',
    'tokenHandling.accessToken',
);

export const getEmailAdress = get('login.userProfile.email');
